export enum EcommerceSocketEvents {
  SuggestionProgress = 'suggestion.progress',
  ScoreUpdated = 'score.updated',
  ApprovalUpdated = 'approval.updated',
}

export interface SuggestionProgressEventPayload {
  ecommerce_id: number;
  product_id: number;
  status: string;
  step: 'started' | 'screenshot_taken' | 'html_scrapped' | 'done' | 'error';
  timestamp: string;
}
